// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4134) return "static/chunks/4134-cba79eadc61e4c27.js";
	if (chunkId === 1318) return "static/chunks/1318-941ad66e811bd267.js";
	if (chunkId === 9066) return "static/chunks/dc112a36-f04c60d5109b227a.js";
	if (chunkId === 5647) return "static/chunks/ca377847-b9b9d2db7ca20aec.js";
	if (chunkId === 8939) return "static/chunks/8939-a9e5f5b476fba7b9.js";
	if (chunkId === 7193) return "static/chunks/7193-2fa2c093e9c2f465.js";
	if (chunkId === 9982) return "static/chunks/9982-0a936ff7fbb6dcb4.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"5940":"020d84de","9268":"aaea2bcf"}[chunkId] || chunkId) + "." + {"37":"33eb9c19c48fd2bf","2804":"72739d2842daeeb5","5221":"883d313fb2c5bcbc","5910":"f6133d14f03eb848","5940":"f1826d41646f3c94","5952":"e3afbf8c334ab8ab","6047":"2c8d799c8734cde1","9268":"9cbfe25e0da5a2a3"}[chunkId] + ".js";
};